import { CameraIcon } from "../../assets/designedPickedIcons";
import dummyUserProfile from "../../assets/dummy-profile-photo.png";

const AvatarInput = ({ value, setValue }) => {
  return (
    <div
      style={{ height: "147px", width: "147px" }}
      className="position-relative"
    >
      <img
        src={
          value && value !== ""
            ? typeof value === "object"
              ? URL.createObjectURL(value)
              : value
            : dummyUserProfile
        }
        height={147}
        width={147}
        style={{background:'rgb(242, 244, 243)'}}
        className="avatar"
      />
      <label
        htmlFor="avatar"
        style={{
          height: "45px",
          width: "45px",
          border: "2.43px solid white",
          right: 0,
        }}
        className="full-rounded p-1 d-flex align-items-center justify-content-center position-absolute  bottom-0 bg-primary-blue"
      >
        <CameraIcon size={34} />
      </label>
      <input
        type="file"
        onChange={(e) => setValue(e?.target?.files[0])}
        className="d-none "
        id="avatar"
      />
    </div>
  );
};

export default AvatarInput;
